var exports = {
  "kL": "x93eb46d8--e3c6a1--container",
  "Wf": "x93eb46d8--e3c6a1--rounded",
  "mc": "x93eb46d8--e3c6a1--middle",
  "as": "x93eb46d8--e3c6a1--large",
  "n2": "x93eb46d8--e3c6a1--extra-large",
  "vu": "x93eb46d8--e3c6a1--active",
};

module.exports = exports;
